'use strict'

/* -----------------------------------------------------------------------------
 * dependencies
 * -------------------------------------------------------------------------- */

// 3rd party
import React from 'react'

// walrus
import Box, { BoxProps } from '../../kit/box'
import Text from '../../kit/text'

// lib
import { ThemeColor } from '../_support'

/* -----------------------------------------------------------------------------
 * SectionHeader
 * -------------------------------------------------------------------------- */

export type SectionHeaderProps = BoxProps & {
  count?: React.ReactNode
  description?: string
  status?: string
  statusColor?: ThemeColor
  title: string
}

function SectionHeader({
  count,
  description,
  status,
  statusColor = 'proTeal',
  title,
  ...otherProps
}: SectionHeaderProps) {
  return (
    <Box {...otherProps}>
      <Box alignItems='baseline' flexDirection='row' gap='08'>
        <Text font='pro.title.20.semibold' textColor='proInk'>
          {title}
        </Text>
        {typeof count !== 'undefined' ? (
          <Text font='pro.text.15.semibold' textColor='proTextFaint'>
            {count}
          </Text>
        ) : null}
        {status ? (
          <Text
            font='pro.text.12.semibold'
            ml='auto'
            textColor={statusColor}
          >
            {status}
          </Text>
        ) : null}
      </Box>
      {description ? (
        <Text
          font='pro.text.13.regular'
          maxWidth={640}
          mb='20'
          mt='08'
          textColor='proTextFaint'
        >
          {description}
        </Text>
      ) : null}
    </Box>
  )
}

export default SectionHeader
